import { combineReducers } from "redux";
import { History } from "history";
import { connectRouter } from "connected-react-router";
import user from "./user/reducers";
import packs from "./dashboard/reducers";
import pack from "./pack/reducers";
import plan from "./plan/reducers";
import teacher from "./teacher/reducers";
import recentPlans from "./recentPlans/reducers";
import browse from "./browse/reducers";
import notifications from "./notification/reducers";
import webp from "./webp/reducers";
import testModeration from "./testModeration/reducers";

export default (history?: History) => combineReducers({
    user,
    packs,
    pack,
    plan,
    recentPlans,
    teacher,
    ...(history && { router: connectRouter(history) }),
    browse,
    notifications,
    webp,
    testModeration,
});
